define(function(require) {
  const tpl = require('civicsViews/problems/templates/t_itv_problem_empty.hbs');

  return Marionette.ItemView.extend({
    template: tpl,
  });
});
